import axiosInstance from "../axiosInstance";
export const notificationService = {
  fetch: async (client_id, query = "", signal) => {
    try {
      let query_obj = `${query}`;
      if (client_id) {
        query_obj += `&client_id=${client_id}`;
      }
      if (!query.includes("sort")) {
        query_obj += `&$sort[createdAt]=-1`;
      }
      let response = await axiosInstance.get(
        `/notification?${query_obj}`,
        signal,
      );
      return response.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  notifyOps: async (notificationId, clientId) => {
    try {
      let response = await axiosInstance.get(
        `/notify-ops?notification_id=${notificationId}&client_id=${clientId}`,
      );
      return response.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
  updateNotification: async (notificationId, data) => {
    try {
      let response = await axiosInstance.patch(
        `/notification/${notificationId}`,
        data,
      );
      return response.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
};
